export const sharedRoutes = [
    {
        path: '/evaluation/templates',
        component: () => import('@/pages/aper/TemplatesView.vue')
    },

    {
        path: '/evaluation/templates/:id',
        component: () => import('@/pages/aper/TemplateView.vue')
    },

    {
        path: '/evaluation/evaluations',
        component: () => import('@/pages/aper/EvaluationsListView.vue')
    },

    {
        path: '/evaluation/evaluations/:id',
        component: () => import('@/pages/aper/EvaluationView.vue'),
        props: true
    },

    {
        path: '/evaluation/evaluations/:id/summary',
        component: () => import('@/pages/aper/EvaluationSummaryView.vue'),
        props: true
    },
]
